import baseRequest from "../_core/baseRequest";

export const courierContractService = {
    /**
     * Kuryenin sözleşmelerini listeler
     * @param {string} courierId - Kurye ID
     * @param {Object} params - Filtreleme parametreleri
     * @returns {Promise<Object>} Sözleşme listesi
     */
    getCourierContracts: async (courierId, params = {}) => {
        const {page = 1, limit = 20, status} = params;
        
        return await baseRequest.get(`/courier/${courierId}/contracts`, {
            params: {
                page,
                limit,
                status,
            },
        });
    },

    /**
     * Kurye sözleşme şablonlarını listeler
     * @param {string} courierId - Kurye ID
     * @returns {Promise<Object>} Şablon listesi
     */
    getCourierContractTemplates: async (courierId) => {
        return await baseRequest.get(`/courier/${courierId}/contract-templates`);
    },

    /**
     * Kurye için yeni sözleşme oluşturur
     * @param {string} courierId - Kurye ID
     * @param {string} templateId - Şablon ID
     * @param {Object} fieldValues - Doldurulan alan değerleri
     * @returns {Promise<Object>} Oluşturulan sözleşme
     */
    createCourierContract: async (courierId, templateId, fieldValues) => {
        return await baseRequest.post(`/courier/${courierId}/contracts`, {
            templateId,
            fieldValues,
        });
    },

    /**
     * Sözleşme önizlemesi oluşturur
     * @param {string} courierId - Kurye ID
     * @param {string} templateId - Şablon ID
     * @param {Object} fieldValues - Doldurulan alan değerleri
     * @returns {Promise<Object>} Önizleme URL'i
     */
    generateContractPreview: async (courierId, templateId, fieldValues) => {
        return await baseRequest.post(`/courier/${courierId}/contracts/preview`, {
            templateId,
            fieldValues,
        });
    },

    /**
     * Sözleşmeleri topluca e-imzaya gönderir
     * @param {string} courierId - Kurye ID
     * @param {string[]} contractIds - Sözleşme ID listesi
     * @returns {Promise<Object>} Toplu e-imza sonucu
     */
    sendContractsToESignatureBulk: async (courierId, contractIds) => {
        return await baseRequest.post(`/courier/${courierId}/contracts/esignature/bulk`, {
            contractIds,
        });
    },

    /**
     * Kurye için dosya yükleyerek sözleşme oluşturur (max 3 dosya)
     * @param {string} courierId - Kurye ID
     * @param {string} templateId - Şablon ID
     * @param {File[]} files - Yüklenecek dosyalar
     * @returns {Promise<Object>} Oluşturulan sözleşme
     */
    uploadCourierContract: async (courierId, templateId, files) => {
        const formData = new FormData();
        files.forEach(file => formData.append("files", file));
        formData.append("templateId", templateId);
        
        return await baseRequest.post(`/courier/${courierId}/contracts`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    /**
     * Kurye sözleşmesini onaylar
     * @param {string} contractId - Sözleşme ID
     * @returns {Promise<Object>} Onay sonucu
     */
    approveCourierContract: async (contractId) => {
        return await baseRequest.post(`/contract/${contractId}/approval`, {
            isApproved: true,
        });
    },

};
